import { Popover } from "antd";
import React, { FC } from "react";
import { CompanyItem } from "shared/api";

interface CompanyInformationProps {
  company: CompanyItem;
}

const PREVIEW_LENGTH = 50;

const CompanyInformation: FC<CompanyInformationProps> = ({ company }) => {
  const information = company?.information;

  if (!information) return null;

  if (information.length <= PREVIEW_LENGTH) return <span>{information}</span>;

  return (
    <Popover
      content={
        <div className="max-w-[400px] max-h-[400px] overflow-y-auto whitespace-pre-wrap break-words">
          {information}
        </div>
      }
    >
      <span className="cursor-default">
        {`${information.substring(0, PREVIEW_LENGTH)}...`}
      </span>
    </Popover>
  );
};

export { CompanyInformation };
